import { Component, Input, OnInit } from '@angular/core';
import { BlogJuridicoService } from 'app/shared/services/wordpress/blog-juridico.service';
import { CategoriaDataDTO } from 'app/shared/models/wordpress/CategoriaDataDTO';
import { DomainService } from 'app/services/domain-service';

export interface ArticuloBlog {
    id?: string;
    categoria: string;
    titulo: string;
    desc: string;
    imagen: any;
    link?: string;
}

@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent implements OnInit {

    private readonly maxDescLength = 110;

    @Input() articulos: ArticuloBlog[] = [];

    constructor(private blogJuridicoService: BlogJuridicoService,
                private domainService: DomainService) {}

    ngOnInit(): void {
        if (this.articulos && this.articulos.length > 0) {
            return;
        }
        const cats: CategoriaDataDTO[] = this.blogJuridicoService.getCategoriasCompletas() || [];
        if (!cats.length) {
            return;
        }
        const flat: ArticuloBlog[] = [];
        cats.forEach(cat => {
            const noticias = (cat.noticasListDestacadas && cat.noticasListDestacadas.length)
                ? cat.noticasListDestacadas
                : (cat.noticiasListAll || []);
            noticias.forEach(n => {
                flat.push({
                    id: n.id,
                    categoria: cat.titulo || '',
                    titulo: n.titulo || '',
                    desc: n.detalle || '',
                    imagen: n.imagen,
                    link: n.link
                });
            });
        });
        this.articulos = flat;
    }

    get items(): ArticuloBlog[] {
        return (this.articulos || []).slice(0, 3);
    }

    imagenUrl(articulo: ArticuloBlog): string {
        if (articulo && articulo.imagen && articulo.imagen.source_url) {
            return articulo.imagen.source_url;
        }
        return '';
    }

    plainDesc(articulo: ArticuloBlog): string {
        if (!articulo || !articulo.desc) {
            return '';
        }
        const text = articulo.desc.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
        if (text.length <= this.maxDescLength) {
            return text;
        }
        const truncated = text.slice(0, this.maxDescLength);
        const lastSpace = truncated.lastIndexOf(' ');
        return (lastSpace > 0 ? truncated.slice(0, lastSpace) : truncated).trim() + '…';
    }

    irA(articulo: ArticuloBlog): void {
        const url = this.urlArticulo(articulo);
        if (!url) { return; }
        window.open(url, '_blank');
    }

    private urlArticulo(articulo: ArticuloBlog): string {
        if (!articulo) { return ''; }
        if (articulo.link) {
            return articulo.link;
        }
        if (articulo.id) {
            return this.domainService.wordpressJuridicoUrl + '/?p=' + articulo.id;
        }
        return '';
    }

    verTodos(): void {
        window.open(this.domainService.wordpressJuridicoUrl, '_blank');
    }
}
